export const getDiscountPercent = (originalPriceThb: number, discountPrice: number) => {
  return Math.ceil(((originalPriceThb - discountPrice) / originalPriceThb) * 100);
};
